const awsmobile = {
  aws_project_region: 'ap-southeast-1',
  aws_cognito_identity_pool_id: 'ap-southeast-1:45404062-ba83-48c8-8706-1ff9f9fd4f60',
  aws_cognito_region: 'ap-southeast-1',
  aws_user_pools_id: 'ap-southeast-1_p112jOu2d',
  aws_user_pools_web_client_id: 'g15mlnucohgdclkelr4v3vumm',
  oauth: {}
}
export default awsmobile
